import React from 'react';

const LogoLoader = (props) => {
    const {
        logoSrc,
        isSettingsLoading,
        imgId,
        maxHeight,
        maxWidth
    } = props;

    return (
        <div>
            {isSettingsLoading ? (
                <p>Loading...</p>
            ) : (
                <img
                    id={imgId}
                    src={logoSrc}
                    alt="Client Logo"
                    style={{
                        maxWidth: maxWidth || '300px',
                        maxHeight: maxHeight || '40px',
                    }}
                />
            )}
        </div>
    );
};


export const LoadLogoLogin = ({ logoSrc, isSettingsLoading, maxHeight, maxWidth }) => (
    <LogoLoader
        imgId="logo-client"
        logoSrc={logoSrc}
        isSettingsLoading={isSettingsLoading}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
    />
);

export const LoadLogoHeader = ({logoSrc, isSettingsLoading, maxHeight, maxWidth }) => (

    <LogoLoader
        imgId="logo-dark-client-header"
        logoSrc={logoSrc}
        isSettingsLoading={isSettingsLoading}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
    />
);

export default { LoadLogoLogin, LoadLogoHeader };
